export const optionsEducation = [
  "Ensino Fundamental",
  "Ensino Médio",
  "Ensino Superior ",
  "Pós-graduado",
  "Mestrado",
  "Doutorado",
];
